import {
  List,
  ListItem,
  Paper,
  ListItemText,
  TextField,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
  Collapse,
  Grid,
  FormLabel,
} from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import Autocomplete from "@material-ui/lab/Autocomplete";
import zhLocale from "date-fns/locale/zh-CN";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import {
  Search,
  Category,
  ConfirmationNumber,
  SortByAlpha,
  WifiTethering,
  ExpandLess,
  ExpandMore,
} from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";
import { withStyles } from "@material-ui/core/styles";
import "date-fns";
import "fontsource-roboto";
import React, { Component } from "react";
import { formateDateSlash, encodePacent } from "../utils/utilTools";

require("../assets/css/style.css");

const useStyles = {
  root: {
    "& > *": {
      paddingTop: "0px",
      paddingBottom: "0px",
      fontSize: "14px",
    },
  },
  inputText: {
    margin: "0 5px 0 0",
    background: "#FFFFFF",
    borderRadius: "4px",
    border: "1px solid #D0D7DD",
  },
  selectText: {
    height: "40px",
    margin: "0 5px 0 0",
    background: "#FFFFFF",
    borderRadius: "4px",
    border: "1px solid #D0D7DD",
  },
  breakLine: {
    margin: "20px 0 0 0",
  },
  breakLineInset: {
    margin: "20px 0 0 16px",
  },
  iconButton: {
    padding: "10px",
    color: "#5d5dcc",
  },
};

class SearchDialogFiles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keyword: "",
      showList: [],
      listIndex: 0,
      date: false,
      selectedDate: new Date(),
      categoryValue: "1",
      pagesize: "10",
      fwOptions: [],
      fwValues: "1",
      randomMean: new Date().getTime(),
      datepick: new Date().getTime(),
      collapseCheck: [],
    };
  }
  componentDidMount() {
    let arr = [];
    for (let index = 0; index < 3; index++) {
      arr[index] = false;
    }
    this.setState({
      collapseCheck: arr,
    });
  }

  setchecked = (index) => {
    let arr = this.state.collapseCheck;
    for (let i = 0; i < 3; i++) {
      if (index === i) {
        arr[i] = !this.state.collapseCheck[i];
      } else {
        arr[i] = false;
      }
    }
    this.setState({
      collapseCheck: arr,
    });
  };
  handleFwChange(ev) {
    this.setState({
      fwValues: ev.target.value,
    });
  }

  handleCategoryChange(ev) {
    this.setState({
      categoryValue: ev.target.value,
    });
  }

  handleSsszChange(name, ev) {
    var gjssform = this.props.initData;
    gjssform[name] = ev.target.value;
    if (name === "zdfw") {
      this.setState({
        randomMean: new Date().getTime(),
      });
    }
    if (name === "sjfw") {
      gjssform["sjfw_to"] = formateDateSlash(new Date().getTime());
      if (gjssform.sjfw === "4") {
        gjssform["sjfw_from"] = formateDateSlash(new Date().getTime());
      } else if (gjssform.sjfw === "2") {
        var from = 0;
        var today = new Date();
        if (today.getMonth() + 1 === 1) {
          today = today.setMonth(12);
          today = today.setFullYear(today.getFullYear() - 1);
          from = today;
        } else {
          today = today.setMonth(today.getMonth() - 1);
          from = today;
        }
        gjssform["sjfw_from"] = formateDateSlash(from);
      } else if (gjssform.sjfw === "1") {
        var from = 0;
        var today = new Date();
        today = today.setFullYear(today.getFullYear() - 1);
        from = today;
        gjssform["sjfw_from"] = formateDateSlash(from);
      } else if (gjssform.sjfw === "0") {
        gjssform["sjfw_from"] = formateDateSlash(new Date("1900/01/01"));
        gjssform["sjfw_to"] = formateDateSlash(new Date().getTime());
      }
    }
    this.props.CustomSetter(gjssform);
  }

  handleZdfwChange(option, ev) {
    let value = "";
    if (option) {
      value = option.value;
    } else {
      value = "0";
    }
    var gjssform = this.props.initData;
    gjssform["zdfw"] = value;
    this.props.CustomSetter(gjssform);
  }

  handleZwgkChange(name, ev) {
    var zwgkform = this.props.xxgkData;
    zwgkform[name] = ev.target.value;
    if (name === "cwrq_from" || name === "cwrq_to") {
      if (new Date(zwgkform.cwrq_from) > new Date(zwgkform.cwrq_to)) {
        return;
      }
    }
    this.props.ZwgkSetter(zwgkform);
  }

  handleZwgkSelChange(name, ev) {
    var zwgkform = this.props.xxgkData;
    zwgkform[name] = ev.target.innerText;
    if (name === "cwrq_from" || name === "cwrq_to") {
      if (new Date(zwgkform.cwrq_from) > new Date(zwgkform.cwrq_to)) {
        return;
      }
    }
    this.props.ZwgkSetter(zwgkform);
  }

  // 修改高级搜索时间范围
  handleDateChange(name, ev) {
    var gjssform = this.props.initData;
    gjssform[name] = formateDateSlash(ev.getTime());
    if (name === "sjfw_from" || name === "sjfw_to") {
      gjssform["sjfw"] = "4";
      if (!gjssform.sjfw_to) {
        gjssform["sjfw_to"] = formateDateSlash(new Date().getTime());
      }
      if (!gjssform.sjfw_from) {
        gjssform["sjfw_from"] = formateDateSlash(new Date().getTime());
      }
      if (new Date(gjssform.sjfw_from) > new Date(gjssform.sjfw_to)) {
        alert("开始时间不能大于结束时间！");
        return;
      }
    }
    this.props.CustomSetter(gjssform);
  }

  handleCwrqChange(name, ev) {
    var zwgkform = this.props.xxgkData;
    zwgkform[name] = formateDateSlash(ev.getTime());
    if (name === "cwrq_from" || name === "cwrq_to") {
      if (new Date(zwgkform.cwrq_from) > new Date(zwgkform.cwrq_to)) {
        return;
      }
    }
    this.props.ZwgkSetter(zwgkform);
  }
  handleRest() {
    this.setState({
      randomMean: new Date().getTime(),
    });
    this.props.CustomReSetter();
  }

  handleSearchInput(ev) {
    this.props.handleCusSearchInput(ev.target.value);
  }

  handleKeyEnter(ev) {
    var keyCode = ev.keyCode;
    if (keyCode === 13) {
      this.props.handleSearchClick();
    }
  }
  render() {
    const _this = this;
    const { classes, xxgkData, isTop } = this.props;

    return (
      <Grid container spacing={1}>
        {isTop ? (
          <form className={classes.root} noValidate autoComplete="off">
            <FormControl style={{ marginLeft: "80px" }} variant="outlined">
              <Autocomplete
                style={{ width: 250 }}
                size="small"
                id="free-solo-demo"
                options={
                  xxgkData.organizations
                    ? xxgkData.organizations.map((option) => option)
                    : ""
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    variant="outlined"
                    label="发布机构"
                  />
                )}
                onChange={_this.handleZwgkSelChange.bind(this, "organization")}
              />
            </FormControl>
            <FormControl
              style={{ marginLeft: "50px", width: "150px" }}
              variant="outlined"
            >
              <TextField
                size="small"
                style={{ width: "150px", top: "16px" }}
                id="zwgkwenhao"
                variant="outlined"
                value={xxgkData.filenumberPre}
                placeholder="机关代字"
                onChange={_this.handleZwgkChange.bind(this, "filenumberPre")}
              />
            </FormControl>
            <FormControl
              style={{ marginLeft: "20px", width: "80px" }}
              variant="outlined"
            >
              <TextField
                size="small"
                style={{ width: "80px", top: "16px" }}
                id="zwgkwenhao"
                variant="outlined"
                value={xxgkData.year}
                placeholder="年份"
                onChange={_this.handleZwgkChange.bind(this, "year")}
              />
            </FormControl>
            <FormControl
              style={{ marginLeft: "20px", width: "166px" }}
              variant="outlined"
            >
              <TextField
                size="small"
                style={{ width: "150px", top: "16px" }}
                id="zwgkwenhao"
                variant="outlined"
                value={xxgkData.filenumber}
                placeholder="文号"
                onChange={_this.handleZwgkChange.bind(this, "filenumber")}
              />
            </FormControl>
            <label style={{ position: "relative", top: "20px" }}>号</label>
            <FormControl
              style={{ marginLeft: "50px", width: "140px" }}
              variant="outlined"
            >
              <Autocomplete
                style={{ width: 250 }}
                size="small"
                id="free-solo-demo1"
                options={
                  xxgkData.groups ? xxgkData.groups.map((option) => option) : ""
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    variant="outlined"
                    label="文种"
                  />
                )}
                onChange={_this.handleZwgkSelChange.bind(this, "group")}
              />
            </FormControl>
          </form>
        ) : (
          <Grid item xs={12}>
            <Grid
              style={{
                height: "50px",
                borderBottom: "1px solid #d1d1d1",
                marginTop: "-12px",
              }}
              item
              xs={8}
            >
              <p className="history-p">文件高级搜索</p>
            </Grid>
            <Paper elevation={0} className="dialog-i">
              <div>
                <List>
                  <form className={classes.root} noValidate autoComplete="off">
                    <ListItem
                      style={
                        this.state.collapseCheck[0]
                          ? { backgroundColor: "rgb(250 250 250)" }
                          : {}
                      }
                    >
                      <Collapse
                        in={this.state.collapseCheck[0]}
                        timeout="auto"
                        collapsedHeight={45}
                      >
                        <List>
                          <ListItem
                            button
                            target="_blank"
                            className="collage-listitemtitle"
                            onClick={() => this.setchecked(0)}
                          >
                            <SortByAlpha color="primary" />
                            &ensp;
                            <ListItemText primary="发布机构" />
                            {this.state.collapseCheck[0] ? (
                              <ExpandLess />
                            ) : (
                              <ExpandMore />
                            )}
                          </ListItem>
                        </List>
                        <ListItem>
                          <FormControl variant="outlined">
                            <Autocomplete
                              style={{ width: 250 }}
                              size="small"
                              id="free-solo-demo"
                              options={
                                xxgkData.organizations
                                  ? xxgkData.organizations.map(
                                      (option) => option
                                    )
                                  : ""
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  margin="normal"
                                  variant="outlined"
                                />
                              )}
                              onChange={_this.handleZwgkSelChange.bind(
                                this,
                                "organization"
                              )}
                              placeholder="机构"
                            />
                          </FormControl>
                        </ListItem>
                      </Collapse>
                    </ListItem>
                    <ListItem
                      style={
                        this.state.collapseCheck[1]
                          ? { backgroundColor: "rgb(250 250 250)" }
                          : {}
                      }
                    >
                      <Collapse
                        in={this.state.collapseCheck[1]}
                        timeout="auto"
                        collapsedHeight={45}
                      >
                        <List>
                          <ListItem
                            button
                            target="_blank"
                            className="collage-listitemtitle"
                            onClick={() => this.setchecked(1)}
                          >
                            <ConfirmationNumber color="primary" />
                            &ensp;
                            <ListItemText primary="发文字号" />
                            {this.state.collapseCheck[1] ? (
                              <ExpandLess />
                            ) : (
                              <ExpandMore />
                            )}
                          </ListItem>
                        </List>
                        <TextField
                          size="small"
                          style={{ width: "150px", marginLeft: "16px" }}
                          className={classes.inputText}
                          id="zwgkwenhao"
                          variant="outlined"
                          value={xxgkData.filenumberPre}
                          placeholder="机关代字"
                          onChange={_this.handleZwgkChange.bind(
                            this,
                            "filenumberPre"
                          )}
                        />
                        <TextField
                          size="small"
                          style={{ width: "80px" }}
                          className={classes.inputText}
                          id="zwgkwenhao"
                          variant="outlined"
                          value={xxgkData.year}
                          placeholder="年份"
                          onChange={_this.handleZwgkChange.bind(this, "year")}
                        />
                        <TextField
                          size="small"
                          style={{ width: "150px", marginLeft: "16px" }}
                          className={classes.inputText}
                          id="zwgkwenhao"
                          variant="outlined"
                          value={xxgkData.filenumber}
                          onChange={_this.handleZwgkChange.bind(
                            this,
                            "filenumber"
                          )}
                        />
                        <label>号</label>
                      </Collapse>
                    </ListItem>
                    <ListItem
                      style={
                        this.state.collapseCheck[2]
                          ? { backgroundColor: "rgb(250 250 250)" }
                          : {}
                      }
                    >
                      <Collapse
                        in={this.state.collapseCheck[2]}
                        timeout="auto"
                        collapsedHeight={45}
                      >
                        <List>
                          <ListItem
                            button
                            target="_blank"
                            className="collage-listitemtitle"
                            onClick={() => this.setchecked(2)}
                          >
                            <Category color="primary" />
                            &ensp;
                            <ListItemText primary="文种" />
                            {this.state.collapseCheck[2] ? (
                              <ExpandLess />
                            ) : (
                              <ExpandMore />
                            )}
                          </ListItem>
                        </List>
                        <FormControl
                          style={{ marginLeft: "16px", width: "140px" }}
                          variant="outlined"
                        >
                          <Autocomplete
                            style={{ width: 250 }}
                            size="small"
                            id="free-solo-demo1"
                            options={
                              xxgkData.groups
                                ? xxgkData.groups.map((option) => option)
                                : ""
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                margin="normal"
                                variant="outlined"
                              />
                            )}
                            onChange={_this.handleZwgkSelChange.bind(
                              this,
                              "group"
                            )}
                            placeholder="文种"
                          />
                        </FormControl>
                      </Collapse>
                    </ListItem>
                  </form>
                </List>
              </div>
            </Paper>
          </Grid>
        )}
      </Grid>
    );
  }
}

export default withStyles(useStyles)(SearchDialogFiles);
